
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/calculators/storage",
      function () {
        return require("private-next-pages/resources/calculators/storage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/calculators/storage"])
      });
    }
  